import { Box } from "@mui/material";

function Logo() {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
            <img style={{ objectFit: "contain", width: "64px", height: "64px" }} src='/images/SHG.png' alt="shg-logo" className='shg-logo' />
            <img style={{ objectFit: "contain", width: "64px", height: "64px" }} src='/images/CTU.png' alt="ctu-logo" className='ctu-logo' />
        </Box>
    );
}

export default Logo;